import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	columnHeaderMergedColumn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	columnHeaderMergedColumn: {
		id: 'native-issue-table.common.utils.get-merged-column-config.column-header-merged-column',
		defaultMessage: 'Work',
		description: 'Column header for merged column',
	},
});
export default messages;
